import { ReactElement, Dispatch, SetStateAction } from 'react';
import { Card, Container, styled, useMediaQuery } from '@mui/material';
import {
  IUser,
  PDFModal,
  TabPanel,
  disableOperationsHelpDesk,
  useRoleOpContext,
} from '../common';
import { labels, panels, TeamNav } from '.';
import {
  find as lfind,
  propOr as lpropOr,
  compose as lcompose,
} from 'lodash/fp';

export const TeamTabs = ({
  user,
  currentTab,
  setCurrentTab,
}: {
  user: IUser;
  currentTab: number;
  setCurrentTab: Dispatch<SetStateAction<number>>;
}) => {
  const { operations } = useRoleOpContext();

  const currentLabel = lcompose(lpropOr('', `[${currentTab}].label`))(
    labels(operations, disableOperationsHelpDesk(operations))
  );

  const child = (
    <Wrapper>
      <PDFModal
        fileUrl={'RA Ops Guide.pdf'}
        fileLabel={'RA Ops Guide'}
        fileDownload="ra_ops_guide.pdf"
      />
      <TeamNav
        currentTab={currentTab}
        operations={operations}
        setCurrentTab={setCurrentTab}
      />

      {currentLabel !== '' && (
        <TabPanel value={currentTab} label={currentLabel}>
          {lfind<{
            value: number;
            panel: () => ReactElement;
          }>({ value: currentTab })(
            panels({
              user,
              disableOperationsHelpDsk: disableOperationsHelpDesk(operations),
            })
          )!.panel()}
        </TabPanel>
      )}
    </Wrapper>
  );

  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  return matchesGridBreakpoint ? (
    <Container maxWidth={false} data-testid="team-testid">
      <Card>{child}</Card>
    </Container>
  ) : (
    child
  );
};

const Wrapper = styled('article')(({ theme }) => ({
  minHeight: '76vh',
  overflowY: 'auto',

  '& > *+*': {
    marginTop: '2rem !important',
  },
}));
